import { render } from "./PlaceImageOnText.vue?vue&type=template&id=8418af0a&scoped=true"
import script from "./PlaceImageOnText.vue?vue&type=script&lang=ts"
export * from "./PlaceImageOnText.vue?vue&type=script&lang=ts"

import "./PlaceImageOnText.vue?vue&type=style&index=0&id=8418af0a&lang=less&scoped=true"
import "./PlaceImageOnText.vue?vue&type=style&index=1&id=8418af0a&lang=less"
script.render = render
script.__scopeId = "data-v-8418af0a"

export default script